import Moment from "react-moment";
import 'moment/locale/de';
// import moment from "moment";

Moment.globalLocale = 'de';
// moment.updateLocale('de', {
//     monthsShort : [
//         "Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
//     ]
// });